import React from "react";
import PropTypes from "prop-types";
import GenericCard from "components/UI/GenericCard/GenericCard";
import DashedTooltip from "components/UI/DashedTooltip";
import { returnUpDownClassname } from "utils/helpers";

const OptionsSuccessRateCard = (props) => {
  const { metrics, params } = props.optionsResults;

  return (
    <GenericCard
      title="Success Rate"
      tooltipText="Based on end-of-day close, not intraday high -- a day only counts as a hit once its CLOSE shows the target gain, matching how you'd actually decide to exit off daily candles."
    >
      <div>
        <h2 className={returnUpDownClassname(metrics.successRate - 50)}>
          {metrics.successRate}%
        </h2>
        <h5>
          closed at +{params.targetGainPercent}% or more within {params.maxDays}{" "}
          bars
        </h5>
        <h5 className="text-xs">
          <DashedTooltip text="Wilson score interval: the range the TRUE success rate plausibly falls in, given only this many signals. Small sample -> wide range (e.g. 8/10 hits gives ~44%-97%, could easily be a 50/50 model that got lucky). Large sample -> tight range you can actually trust (e.g. 160/200 gives ~74%-85%). Check this width before sizing a trade off the headline %.">
            95% confidence:
          </DashedTooltip>{" "}
          {metrics.successRateConfidenceInterval.lower}% -{" "}
          {metrics.successRateConfidenceInterval.upper}%
        </h5>
      </div>
      <div className="pt-2 flex gap-8">
        <div>
          <h5>Signals</h5>
          <h3>
            {metrics.completeSignals}
            {metrics.incompleteSignals > 0 && (
              <span className="text-xs">
                {" "}
                (+{metrics.incompleteSignals} incomplete)
              </span>
            )}
          </h3>
        </div>
        <div>
          <h5>Avg bars to hit</h5>
          <h3>{metrics.avgDaysToHit || "N/A"}</h3>
        </div>
        <div>
          <h5>Hit before min bar ({params.minDays})</h5>
          <h3>{metrics.prematureHitRate}%</h3>
        </div>
        <div>
          <DashedTooltip text="Success rate over just the most recent signals -- the all-time number can look great while the edge has quietly gone stale. Worth comparing against the headline rate above.">
            <h5>Recent (last {metrics.recentSuccessRate.windowSize})</h5>
          </DashedTooltip>
          <h3
            className={returnUpDownClassname(
              metrics.recentSuccessRate.successRate - metrics.successRate,
            )}
          >
            {metrics.recentSuccessRate.successRate}%
          </h3>
        </div>
      </div>
    </GenericCard>
  );
};

OptionsSuccessRateCard.propTypes = { optionsResults: PropTypes.object };

export default OptionsSuccessRateCard;
